var React = require('react');

function BlobBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m253.62 182.79-19.22 19.57a14.27 14.27 0 0 0 0 20l19.22 19.57a14.27 14.27 0 0 1 -.16 20.15 14.25 14.25 0 0 1 -20.16-.15l-18.53-18.8a14.25 14.25 0 0 0 -20.33 0l-18.44 18.78a14.27 14.27 0 0 1 -20.15.2v-.05a14.25 14.25 0 0 1 -.2-20.18l19.18-19.54a14.25 14.25 0 0 0 0-20l-19.23-19.52a14.24 14.24 0 0 1 .2-20.17v-.06a14.27 14.27 0 0 1 20.15.2l18.44 18.79a14.27 14.27 0 0 0 20.33 0l18.53-18.81a14.25 14.25 0 0 1 20.16-.14 14.25 14.25 0 0 1 .21 20.16z","fill":"#2a6fab"}));
}

BlobBlue.defaultProps = {"viewBox":"0 0 410 405"};

module.exports = BlobBlue;

BlobBlue.default = BlobBlue;
